import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const commsApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "commsApi",
  tagTypes: ["NewsFeed", "DidYouKnow", "Notifications", "Banner"],
  endpoints: (builder) => ({
    getDashboardBanners: builder.query<API.Response.DashboardBannerResponse, void>({
      query: () => "/recognition/banners",
      providesTags: ["Banner"],
    }),
    getNotifications: builder.mutation<API.Response.Notifications, void>({
      query: (payload) => ({
        url: `newsfeed/notification/new`,
        method: "POST",
        body: payload,
      }),
    }),
    clearNotifications: builder.mutation({
      query: (payload) => ({
        url: `newsfeed/notification/clear`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const { useGetNotificationsMutation, useClearNotificationsMutation, useGetDashboardBannersQuery } = commsApi
